import { Skeleton } from './Skeleton'

/**
 * 조회 중 공통 표현.
 * 스피너 대신 **레이아웃 보존형 스켈레톤**을 쓴다 — 로딩이 끝날 때 화면이 튀지 않는다.
 */
export function LoadingState({
  rows = 3,
  label = '불러오는 중',
}: {
  rows?: number
  label?: string
}) {
  return (
    <div role="status" aria-live="polite" aria-busy="true" className="space-y-3">
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} className="h-16 w-full" />
      ))}
    </div>
  )
}
